var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _vm.contact
        ? _c("app-sidebar-contact-details-block", {
            attrs: { item: _vm.contact },
            on: {
              summary: function ($event) {
                return _vm.$emit("summary", $event)
              },
            },
          })
        : !_vm.loaded
        ? _c(
            "div",
            { staticClass: "sidebar-loading" },
            [_c("w-progress-circular", { attrs: { small: "" } })],
            1
          )
        : _c("div", { staticClass: "sidebar-empty" }, [
            _vm._v(_vm._s(_vm.$ct("sidebar.crm-contact.none"))),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }